import React, { Component } from 'react';
import { connect } from 'react-redux';
import './ReceiptsTable.css';
import SimpleTable from 'components/shared/table/SimpleTable';
import Number from 'components/shared/text/Number';
import ImageUpload from 'components/shared/image-upload/ImageUpload';
import Button from 'components/shared/button/Button';
import ConfirmationModal from 'components/shared/modal/ConfirmationModal';
import {
  deleteReceipt,
  setReceiptToEdit,
  setShowAddMaterialsModal,
} from 'components/admin/work-orders/details/receipts/store/actions';
import AddMaterialsModal from 'components/admin/work-orders/details/receipts/AddMaterialsModal';
import {
  receiptsSelector,
  showAddMaterialsModalSelector,
} from 'components/admin/work-orders/details/receipts/store/selectors';
import DocumentLink from 'components/shared/document/DocumentLink';

class ReceiptsTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      receiptIdToDelete: null,
      showDeleteConfirmation: false,
    };
  }

  handleDeleteConfirmation = (response) => {
    if (response) {
      this.props.dispatch(deleteReceipt(this.state.receiptIdToDelete));
    }
    this.setState({
      receiptIdToDelete: null,
      showDeleteConfirmation: false,
    });
  };

  mapReceipts = (receipts) => {
    return receipts.map((receipt) => {
      return [
        receipt.task_number,
        <Number value={receipt.cost} format="$0,0.[00]" />,
        receipt.description,
        receipt.image !== null ? (
          <ImageUpload
            images={[
              {
                id: receipt.image.id,
                url: receipt.image.image.url,
                preview: receipt.image.image.preview.url,
              },
            ]}
            readOnly={true}
          />
        ) : (
          ''
        ),
        receipt.document !== null ? (
          <DocumentLink url={receipt.document.document.url} />
        ) : (
          ''
        ),
        <div className="edit-delete-buttons-container">
          <Button
            className="button-blue-grey"
            label="Edit"
            onClick={() => {
              this.props.dispatch(setReceiptToEdit(receipt));
              this.props.dispatch(setShowAddMaterialsModal(true));
            }}
          />
          <Button
            className="button-blue-grey"
            label="Delete"
            onClick={() =>
              this.setState({
                receiptIdToDelete: receipt.id,
                showDeleteConfirmation: true,
              })
            }
          />
        </div>,
      ];
    });
  };

  render() {
    const headers = [
      'TASK #',
      'AMOUNT',
      'DESCRIPTION',
      'PHOTO',
      'DOCUMENT',
      '',
    ];

    return (
      <div className="receipts-table-container">
        <SimpleTable
          className="receipts-table"
          headers={headers}
          rows={this.mapReceipts(this.props.receipts)}
          emptyMessage="No Materials"
        />
        <Button
          className="button-orange add-materials-button"
          label="Add Materials"
          onClick={() => {
            this.props.dispatch(setReceiptToEdit(null));
            this.props.dispatch(setShowAddMaterialsModal(true));
          }}
        />
        {this.props.showMaterialsModal && <AddMaterialsModal />}
        <ConfirmationModal
          show={this.state.showDeleteConfirmation}
          message="Are you sure you want to delete the item?"
          onHide={this.handleDeleteConfirmation}
        />
      </div>
    );
  }
}

export default connect((state) => {
  return {
    receipts: receiptsSelector(state),
    showMaterialsModal: showAddMaterialsModalSelector(state),
  };
})(ReceiptsTable);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/receipts/ReceiptsTable.js